import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaginationComponent } from './pagination.component';
import { StackModule } from '../stack/stack.module';
import { ButtonModule } from '../button/button.module';
import { TextModule } from '../text/text.module';
import { PaginationButtonsModule } from './pagination-buttons.module'
import { SelectModule } from '../select/select.module'
@NgModule({
  declarations: [PaginationComponent],
  imports: [CommonModule, StackModule, ButtonModule, TextModule, PaginationButtonsModule, SelectModule],
  exports: [PaginationComponent],
})
export class PaginationModule {}
